import Marquee from "react-fast-marquee";

const items = [
  "EVIDENCE-BASED CLINICAL NUTRITION",
  "GUT HEALTH RESTORATION",
  "HOLISTIC HEALING",
  "MEDICAL NUTRITION THERAPY",
];

export default function EditorialMarquee() {
  return (
    <div
      className="bg-[#2C3C30] py-6 md:py-8 border-y border-[#2C3C30]"
      data-testid="editorial-marquee"
    >
      <Marquee speed={45} gradient={false} autoFill>
        {items.map((t, i) => (
          <span key={i} className="flex items-center">
            <span className="font-serif italic text-[#F7F6F2] text-3xl md:text-5xl px-8">
              {t}
            </span>
            <span className="text-[#7D8C7A] text-3xl md:text-5xl">&bull;</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
